const INTEGRATION = 'https://editorial-int.uefa.com';
const PREPROD = 'https://editorial-pre.uefa.com';
const PROD = 'https://editorial.uefa.com';
const LOCAL = PREPROD;

function getEnv() {
  const isLocalhost = window.location.hostname === 'localhost';
  const qsParams = new URLSearchParams(window.location.search);
  const qsEnv = isLocalhost ? 'pre' : qsParams.get('env');

  return qsEnv ?? import.meta.env.VITE_APP_ENVIRONMENT;
}

function getEnvProperties() {
  switch (getEnv()) {
    case 'int':
      return INTEGRATION;
    case 'pre':
      return PREPROD;
    case 'prod':
      return PROD;
    default:
      return LOCAL;
  }
}

const env = getEnv();
const baseUrl = getEnvProperties();

export { baseUrl, env };
